import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import './ToolTip.css';


class ToolTip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
        }
    }

    showTooltip = () => {
        this.setState({isVisible: true});
    }

    hideTooltip = () => {
        this.setState({isVisible: false});
    }

    handleClickOutside = () => {
        this.setState({isVisible: false});
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside, false);
    }

    getContainerClassName = () => {
        if (this.props.isMobileOn) {
            return "icon-tooltip-container-mobile";
        }
        if (this.state.isVisible) {
            return "icon-tooltip-container";
        }
        return "icon-tooltip-container hidden";
    }

    render = () => (
        <div className={this.getContainerClassName()} 
            onMouseOver={() => this.showTooltip()} 
            onFocus={() => this.showTooltip()} 
            onMouseLeave={() => this.hideTooltip()} 
        >
            <div className={"tooltip-container"} >
                <div className="tooltip-label">
                    <p>{this.props.item.id}</p>
                </div>
                <div className="tooltip-arrow"></div>
            </div>
            <FontAwesomeIcon icon={faInfo} color="#d1d1d1" size="sm" />
        </div>
    )
}

export default ToolTip